import {
  isFacebookPublishableConnection,
  isInstagramPublishableConnection,
  isSendableConnection,
  isYouTubePublishableConnection,
} from '@/lib/publishing/resolvePublishEligibility';
import type { PublishConnection } from '@/lib/publishing/types';

/** Publishing-scope reconnect nags are only useful when the viewer can post. */
export function shouldShowPublishReconnectNotice(
  connection: PublishConnection,
  { hasSocialPublishing, canPostToFacebook = false }: {
    hasSocialPublishing: boolean;
    /** Whether `mySocialPostingPlatforms` lists Facebook for the viewer. */
    canPostToFacebook?: boolean;
  },
): boolean {
  if (!hasSocialPublishing || connection.status !== 'active') return false;
  if (connection.platform === 'tiktok') return !isSendableConnection(connection);
  if (connection.platform === 'youtube') return !isYouTubePublishableConnection(connection);
  if (connection.platform === 'instagram') return !isInstagramPublishableConnection(connection);
  if (connection.platform === 'facebook') {
    return canPostToFacebook && !isFacebookPublishableConnection(connection);
  }
  return false;
}

/** i18n key for the notice body; each platform has its own wording. */
export function publishReconnectNoticeKey(platform: string): string {
  if (platform === 'youtube') return 'account.youtubeReconnectRequired';
  if (platform === 'facebook') return 'account.facebookReconnectRequired';
  return 'publishing.reconnectBody';
}
